import React, { FC } from "react";

import amazon from "../../images/home-screenshots/amazon.png";
import backlink from "../../images/home-screenshots/backlinks.png";
import convertImage from "../../images/home-screenshots/convert-images.png";
import googleMaps from "../../images/home-screenshots/google-maps.png";
import scraping from "../../images/home-screenshots/scraping.png";
import screenshots from "../../images/home-screenshots/screenshots.png";
import seoAnalysis from "../../images/home-screenshots/seo-analysis.png";
import translate from "../../images/home-screenshots/translate.png";
import AutomationsCarusel from "../automations-courusel";
import hexomaticGif from "../../images/Hexomatic_Translation.gif";
import "./styles.scss";
import { navigate } from "gatsby-link";

const MiddleSection: FC = () => {
  return (
    <>
      <div className="row mt-5">
        <h2 className="col-12 f_size_26 f_700 t_color3 l_height45 mt_10 mb-20 text-center">
          Harness the internet as your own data source
        </h2>
        <div className="order-2 order-lg-1 col-lg-6 text-center">
          <img
            src={hexomaticGif}
            alt="workflow"
            style={{ maxWidth: "500px", width: "100%" }}
          />
        </div>
        <div className="order-1 order-lg-2 col-lg-6 m-auto">
          <p>
            Create your own scraping recipes in minutes to turn any website into
            a spreadsheet or JSON API.
          </p>
          <p>
            Hexomatic makes it easy to scrape products, directories, prospects
            and listings at scale with a simple point and click experience. No
            coding required.
          </p>
        </div>
      </div>
      <AutomationsCarusel
        title="Ready made automations to perform tasks on autopilot"
        subtitle="Find new prospects for any industry, discover email or social media
            profiles, translate content, enrich your leads with tech stack data,
            get traffic estimates at scale and more."
        subtitle2="Hexomatic features 70+ ready made automations you can deploy in
            minutes."
      />
      <div className="row mt-5 mb_20">
        <div className="col-12">
          <h2 className="f_size_26 f_700 t_color3 l_height45 mt_20 mb-20 text-center">
            You are just one workflow away from saving 100+ hours a month
          </h2>
          <p className="text-center">
            Combine your own scraping recipes and our ready made automations to
            create powerful workflows you can run on autopilot.
          </p>
        </div>
        <div className="popular-use-cases" style={{cursor: 'pointer'}} onClick={() => navigate('/use-cases')}>Popular use cases</div>
      </div>

      {/* flow 1 */}

      <div className="row">
        <div className="col-lg-6 order-1 order-lg-2 justify-content-center text-lg-left text-center">
          {/* <h5 className="f_size_24 l-height36 f_400">Popular use cases</h5> */}
          <h2 className="f_size_20 l-height24 f_600 mb_20">
            Scrape and analyze listings from any website
          </h2>
          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Scraping recipe</h3>
              <p className="f_size_14 m-0">
                Scrape data from any website capturing product names,
                descriptions, prices, images etc.
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">SEO meta tags</h3>
              <p className="f_size_14 m-0">
                Extract SEO meta title and meta descriptions for each product
                page
              </p>
            </div>
          </div>
          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>3</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Content analysis</h3>
              <p className="f_size_14 m-0">
                Calculate word count for each product page
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-6 order-1 order-lg-2 text-center d-flex">
          <img
            className="automation-flows m-auto"
            src={scraping}
            alt="Scraping"
          />
        </div>
      </div>

      {/* flow 2 */}
      <div className="row">
        <div className="order-2 order-lg-1 col-lg-6 text-center d-flex">
          <img
            className="automation-flows m-auto"
            src={googleMaps}
            alt="Google Maps"
          />
        </div>
        <div className="order-1 order-lg-2 col-lg-6 justify-content-center text-lg-left text-center">
          <h2 className="f_size_20 l-height24 f_600 mb_20 d-flex  justify-content-lg-start justify-content-center">
            <p style={{ width: "500px" }}>
              Find 100's of prospects in a few clicks using Google Maps
            </p>
          </h2>
          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Google Maps</h3>
              <p className="f_size_14 m-0">Find leads using Google Maps </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Email scraper</h3>
              <p className="f_size_14 m-0">
                Find email addresses for each prospect
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>3</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Social links scraper</h3>
              <p className="f_size_14 m-0">Find social media profiles</p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>4</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Discover Tech Stack</h3>
              <p className="f_size_14 m-0">
                Analyze the tech stack data of each website
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* flow 3 */}
      <div className="row">
        <div className="col-lg-6 order-2 order-lg-1 justify-content-center text-lg-left text-center">
          <h2 className="f_size_20 l-height24 f_600 mb_20">
            Monitor Amazon sellers for specific products
          </h2>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">
                Amazon product search
              </h3>
              <p className="f_size_14 m-0">
                Provide the ASIN for a product on Amazon
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Currency converter</h3>
              <p className="f_size_14 m-0">
                Get data for each seller of an amazon product including price,
                condition and rating
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-6 order-2 order-lg-2 text-center d-flex">
          <img
            className="automation-flows-small m-auto"
            src={amazon}
            alt="Monitor Amazon sellers"
          />
        </div>
      </div>

      {/* flow 4 */}
      <div className="row">
        <div className="order-2 order-lg-1 col-lg-6 text-center d-flex">
          <img
            className="automation-flows m-auto"
            src={backlink}
            alt="Supercharge your SEO backlinks outreach"
          />
        </div>
        <div className="order-1 order-lg-2 col-lg-6 justify-content-center text-lg-left text-center">
          <h2 className="f_size_20 l-height24 f_600 mb_20">
            Supercharge your SEO backlinks outreach
          </h2>
          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Google Search</h3>
              <p className="f_size_14 m-0">
                Find all websites that mention a product or brand using the
                Google search automation
              </p>
            </div>
          </div>
          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Email scraper</h3>
              <p className="f_size_14 m-0">
                Find email addresses for each website for outreach
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>3</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Social links scraper</h3>
              <p className="f_size_14 m-0">
                Find social media profiles to connect directly from social
                networks
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>4</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Traffic insights</h3>
              <p className="f_size_14 m-0">
                Get traffic estimates to prioritize prospects
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* flow 5 */}

      <div className="row">
        <div className="col-lg-6 order-1 justify-content-center text-lg-left text-center">
          <h2 className="f_size_20 l-height24 f_600 mb_20">
            Create screenshots in bulk for any device size
          </h2>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">
                Extract links from a page
              </h3>
              <p className="f_size_14 m-0">
                Provide a list of URLs or a spreadsheet
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Screenshot capture</h3>
              <p className="f_size_14 m-0">
                Create a screenshot for each URL (7 device sizes available
                including mobile and 4K desktop)
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-6 order-2 text-center d-flex">
          <img
            className="automation-flows-small m-auto"
            src={screenshots}
            alt="Create screenshots"
          />
        </div>
      </div>

      {/* flow 6 */}
      <div className="row">
        <div className="order-2 order-lg-1 col-lg-6 text-center d-flex">
          <img
            className="automation-flows m-auto"
            src={seoAnalysis}
            alt="Perform SEO analysis"
          />
        </div>
        <div className="order-1 order-lg-2 col-lg-6 justify-content-center text-lg-left text-center">
          <h2 className="f_size_20 l-height24 f_600 mb_20">
            Perform SEO analysis at scale
          </h2>
          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Sitemap extractor</h3>
              <p className="f_size_14 m-0">
                Provide the XML sitemap URL of any website
              </p>
            </div>
          </div>
          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">SEO meta tags</h3>
              <p className="f_size_14 m-0">
                For each page capture the SEO meta tags (title, description,
                Open Graph etc)
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>3</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Content analysis</h3>
              <p className="f_size_14 m-0">Calculate word count</p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>4</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">
                Extract links from a page
              </h3>
              <p className="f_size_14 m-0">
                Extract internal or external links
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>5</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Get page content</h3>
              <p className="f_size_14 m-0">Scrape specific content tags</p>
            </div>
          </div>
        </div>
      </div>

      {/* flow 7 */}

      <div className="row">
        <div className="col-lg-6 order-1 justify-content-center text-lg-left text-center">
          <h2 className="f_size_20 l-height24 f_600 mb_20">
            Convert images at scale
          </h2>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">
                Files &amp; Documents finder
              </h3>
              <p className="f_size_14 m-0">Provide a list of image URLs</p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Image converter</h3>
              <p className="f_size_14 m-0">
                Convert images in JPG, PNG or PDF formats
              </p>
            </div>
          </div>
        </div>
        <div className="col-lg-6 order-2 text-center d-flex">
          <img
            className="automation-flows-small m-auto"
            src={convertImage}
            alt="Convert images"
          />
        </div>
      </div>

      {/* flow 8 */}

      <div className="row">
        <div className="col-lg-6 order-2 order-lg-1 text-center d-flex">
          <img
            className="automation-flows-small m-auto"
            src={translate}
            alt="Translate ad creatives or products"
          />
        </div>
        <div className="col-lg-6 order-1 order-lg-2 justify-content-center text-lg-left text-center">
          <h2 className="f_size_20 l-height24 f_600 mb_20">
            Translate ad creatives or products at scale
          </h2>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>1</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">Data input</h3>
              <p className="f_size_14 m-0">
                Provide CSV file containing a list of text
              </p>
            </div>
          </div>

          <div className="d-lg-flex mb_20">
            <div className="order-number-circle d-none d-lg-block">
              <span>2</span>
            </div>
            <div>
              <h3 className="f_size_18 mb-1 f_500 m-0">DeepL Translation</h3>
              <p className="f_size_14 m-0">
                For each row translate to any language using DeepL
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MiddleSection;
